import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const ProceduresIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/procedures'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return {
              name: 'settings_procedures_list',
              params: to.params,
            };
          },
        },
        {
          path: 'list',
          name: 'settings_procedures_list',
          component: ProceduresIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
